import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import {
    StationDiscrepancyCorrectionKind,
    StationDiscrepancyCorrectionMapping,
} from '@models/station-discrepancy';

@Component({
    selector: 'app-correction-field',
    imports: [MatIconModule, CommonModule],
    template: `
        @if (correctionProperty; as property) {
            <span
                class="correction flex items-center gap-5"
                [ngClass]="'bg-' + property.backgroundColor">
                <mat-icon
                    [svgIcon]="property.icon"
                    [ngClass]="'color-' + property.iconColor" />
                <span [ngClass]="'color-' + property.labelColor">
                    {{ property.label }}
                </span>
            </span>
        } @else {
            -
        }
    `,
    styles: `
        :host {
            height: 100%;
            display: flex;
            align-items: center;

            .correction {
                border: 1px solid #d9d9d9;
                padding: 6px 8px;
                height: 30px;
            }

            ::ng-deep.mat-icon {
                display: flex;
            }
        }
    `,
})
export class CorrectionFieldComponent {
    @Input({ required: true })
    correction!: StationDiscrepancyCorrectionKind | null;

    get correctionProperty() {
        if (this.correction === null || this.correction === undefined) {
            return null;
        }

        return StationDiscrepancyCorrectionMapping[this.correction];
    }
}
